<div class="container-fluid">
    <div class="row mb-2">
        <div class="col-md-12">
            <div class="row align-items-center">
                <div class="col-md-1 text-center">
                    <i class="fa-solid fa-comments fa-2xl"></i>
                </div>
                <div class="col-md-11">
                    <h5>es simplemente el texto de relleno de las &iacute;mprentas y archivos de texto. Lorem Ipsum ha
                        sido el texto de
                        relleno est&aacute;ndar de las industrias desde el a&ntilde;o 1500, cuando un impresor</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col-md-12">
            <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
            <div class="rounded" style="background-color: var(--app-claro, #53aaed); padding: 0.5em 0;">
                <div class="row align-items-center" style="color: white; text-align: center;">
                    <div class="col-md-2"><i class="fa fa-wallet fa-2x"></i></div>
                    <div class="col-md-8">
                        <h4 class="mb-0" style="color: white">CUENTAS PENDIENTES</h4>
                    </div>
                </div>
            </div>
            <div style="background-color: black; padding: 0.5em 0; color: white;">
                <div class="row align-items-center">
                    <div class="col-md-2 offset-md-8 offset-sm-0 col-sm-12" style="text-align: right">
                        <h5 class="mb-0" style="color: white; padding-right: 1em;">
                            <i class="fa-regular fa-calendar"></i> &nbsp; {{ahora | date: 'yyyy/MM/dd' }}
                        </h5>
                    </div>
                    <div class="col-md-2 col-sm-12" style="text-align: right">
                        <h5 class="mb-0" style="color: white; padding-right: 1em;">
                            <i class="fa-regular fa-clock"></i>&nbsp; {{ahora | date: 'hh:mm a' }}
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="cuentasPendientes" *ngIf="pantallaPago == 0">
        <div class="row mb-1">
            <div class="col-md-7">
                <div class="card">
                    <div class="card-body">
                        <h4 class="azul"><b>Cuentas pendientes</b></h4>
                        <hr class="azul">

                        <table class="table no-hover tbcostos">
                            <tbody>
                                <tr class="subtitulo azul">
                                    <td>Descripción</td>
                                    <td>Costos</td>
                                </tr>
                                <tr>
                                    <td>Métodos y técnicas de estudio - 3 créditos</td>
                                    <td>125000</td>
                                </tr>
                                <tr class="subtitulo  azul">
                                    <td>Cobros</td>
                                    <td>125000</td>
                                </tr>
                                <tr>
                                    <td>Matrícula</td>
                                    <td>0</td>
                                </tr>
                                <tr>
                                    <td>Colegiatura</td>
                                    <td>125000</td>
                                </tr>
                                <tr>
                                    <td>Otros</td>
                                    <td>125000</td>
                                </tr>
                                <tr class="subtitulo  azul">
                                    <td>Incentivos</td>
                                    <td>125000</td>
                                </tr>
                                <tr>
                                    <td>Becas</td>
                                    <td>125000</td>
                                </tr>
                                <tr>
                                    <td>Descuentos</td>
                                    <td>125000</td>
                                </tr>
                                <tr class="subtitulo  azul">
                                    <td>Subtotal</td>
                                    <td>125000</td>
                                </tr>
                                <tr>
                                    <td>Impuestos</td>
                                    <td>125000</td>
                                </tr>
                                <tr class="subtitulo  azul">
                                    <td>Total a pagar</td>
                                    <td>125000</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-md-5">
                <div class="card">
                    <div class="card-body">
                        <h4 class="azul"><b>Ayuda económica</b></h4>
                        <hr class="azul">
                        <div class="row">
                            <div class="col-md-6">
                                <h6 class="mb-1 azul">Financiamientos</h6>
                                <h5 class="mb-0 azul"><b>50% Matrícula</b></h5>
                                <h5 style="color: #74bc1f"><i class="fa fa-circle-check"></i> Aprobado</h5>

                                <p class="mt-2">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                                    sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
                                    ex ea commodo consequat.
                                </p>

                                <h5><button class="btn"
                                        style="text-decoration: underline; color: gray;">Consultar</button></h5>
                            </div>
                            <div class="col-md-6">
                                <h6 class="mb-1 azul">Beca</h6>
                                <h5 class="mb-0 azul"><b>Nombre de la beca</b></h5>
                                <h5 style="color: #74bc1f"><i class="fa fa-circle-check"></i> Aprobado</h5>

                                <p class="mt-2">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                                    sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
                                    ex ea commodo consequat.
                                </p>

                                <h5><button class="btn"
                                        style="text-decoration: underline; color: gray;">Consultar</button></h5>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-7">
                <div class="card">
                    <div class="card-body">
                        <h4 class="azul"><b>Método de pago</b></h4>
                        <hr class="azul">

                        <ng-select style="width: 50%" [items]="metodosPago" bindLabel="label" bindValue="value" [(ngModel)]="metodoPagoSeleccionado">
                            
                        </ng-select>

                        <ng-container *ngIf="metodoPagoSeleccionado == 1; else metodos">
                            <p class="mt-3">
                                Por favor dirijase a una de las cajas en la universidad para cancelar esta deuda.Puede
                                imprimir un recibo
                                provisional con las opciones que se muestran
                            </p>
                            <button type="button" style="float: right" class="btn btn-info mt-3">Imprimir
                                Factura</button>
                        </ng-container>

                        <ng-template #metodos>
                            <button type="button" (click)="adelante()" style="float: right" class="btn btn-info mt-3">Cancelar
                                Pendientes</button>
                        </ng-template>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="cancelarPendientes" *ngIf="pantallaPago == 1">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="azul"><b>Cancelar Pendientes</b></h4>
                        <hr class="azul">
                        
                        <div class="row">
                            <div class="col-md-4">
                                <label class="azul"><b>Método de pago</b></label>
                                <ng-select [items]="metodosPago" bindLabel="label" bindValue="value" [(ngModel)]="metodoPagoSeleccionado">
                                </ng-select>
                                <p class="mt-3" *ngIf="metodoPagoSeleccionado == 3">Por favor sirvase a introducir los detalles de su tarjeta en el formulario</p>
                                <p class="mt-3" *ngIf="metodoPagoSeleccionado == 2">Si ya realizó una transferencia o depósito en el banco a favor de la universidad,
                                    por favor sirvase a introducir los detalles en el siguiente formulario. De lo contrario haga la transferencia o depósito primero.
                                </p>
                            </div>
                            <div class="col-md-4" *ngIf="metodoPagoSeleccionado == 3">
                                <div class="row">
                                    <label class="col-md-4">Nombre de la tarjeta</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-md-4">Número de la tarjeta</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-md-4">Vencimiento</label>
                                    <div class="col-md-4">
                                        <ng-select>

                                        </ng-select>
                                    </div>
                                    <div class="col-md-4">
                                        <ng-select>
                                            
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-md-4">Código de la tarjeta</label>
                                    <div class="col-md-8">
                                        <input type="text" key class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4" *ngIf="metodoPagoSeleccionado == 2">
                                <div class="row">
                                    <label class="col-md-4">Sede</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-md-4">Cuenta bancaria</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-md-4">Nombre del depositante</label>
                                    <div class="col-md-4">
                                        <ng-select>

                                        </ng-select>
                                    </div>
                                    <div class="col-md-4">
                                        <ng-select>
                                            
                                        </ng-select>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-md-4">Número del depósito</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-md-4">Número del depósito</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-md-4">Monto del depósito</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-md-4">Concepto del pago</label>
                                    <div class="col-md-8">
                                        <textarea class="form-control" rows="5"></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div style="padding: 4em; background-color: #f5f5f5; text-align: center;">
                                    <h5 class="azul"><b>Total a cancelar</b> </h5>
                                    <h4><b>1,450.00</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2 offset-md-8">
                                <button type="button" class="btn btn-secondary w-100" (click)="atras()">Cancelar</button>
                            </div>
                            <div class="col-md-2">
                                <button type="button" class="btn btn-info w-100" (click)="adelante()">Pagar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="confirmacion" *ngIf="pantallaPago == 2">
      <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <h4 class="azul"><b>Confirmación</b></h4>
                    <hr class="azul">
    
                    <div class="row align-items-center">
                        <div class="col-md-8" *ngIf="metodoPagoSeleccionado == 3">
                            <p>
                                <label class="azul">Método de pago:</label>
                                Master/Visa
                            </p>
                            <p>
                                <label class="azul">Tipo de tarjeta:</label>
                                Master card
                            </p>
                            <p>
                                <label class="azul">Número de la tarjeta:</label>
                                11-1111111-1111
                            </p>
                            <p>
                                <label class="azul">Vencimiento:</label>
                                05/22
                            </p>
                            <p>
                                <label class="azul">Nombre de la tarjeta:</label>
                                Mario Mora Mora
                            </p>
                        </div>

                        <div class="col-md-4" *ngIf="metodoPagoSeleccionado == 2">
                            <p>Esta información será verificada por nuestro departamento de finanzas 
                                y le enviarán una confirmación de haber recibido la misma</p>
                        </div>

                        <div class="col-md-4" *ngIf="metodoPagoSeleccionado == 2">
                            <p>
                                <label class="azul">Sede:</label>
                                Nombre de la sede
                            </p>
                            <p>
                                <label class="azul">Cuenta bancaria:</label>
                                0000000000000000000000000
                            </p>
                            <p>
                                <label class="azul">Nombre del depositante</label>
                                Mario Mora Mora
                            </p>
                            <p>
                                <label class="azul">Número del depósito:</label>
                                1111111111111111
                            </p>
                            <p>
                                <label class="azul">Concepto:</label>
                                Matrícula semestre de 2022
                            </p>
                        </div>
                        <div class="col-md-4">
                            <div style="padding: 4em; background-color: #f5f5f5; text-align: center;">
                                <h5 class="azul"><b>Total a cancelar</b> </h5>
                                <h4><b>1,450.00</b></h4>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4 offset-md-8 mt-3">
                            <button type="button" (click)="imprimirPantalla()" class="btn btn-info w-100" *ngIf="metodoPagoSeleccionado == 2;else facturaTarjeta">Notificar depósito</button>
                            <ng-template #facturaTarjeta>
                                <button type="button" class="btn btn-info w-100">Enviar recibo</button>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
      </div> 
    </div>
</div>